import { css, unsafeCSS } from 'lit-element';
import { border_box as borderBox } from '@aab/sc-styles-grid';
import { text_intro } from '@aab/sc-styles-typography';
import {
  shadow_tile, text_left, d_flex, justify_content_between, align_items_center,
} from '@aab/sc-styles-utilities';
import {
  white, n670,
} from '@aab/sc-styles-colors';
import {
  p_2, pl_2, mt_1,
} from '@aab/sc-styles-spacing';

// box-sizing: border-box; (borderBox) is required in order to include padding and border in the width and height of an element
// the borderBox class makes sure the grid works and makes creating lay-outs easier and more intuitive
const styles = css`
  ${unsafeCSS(borderBox)}
  ${unsafeCSS(shadow_tile)}
  ${unsafeCSS(p_2)}
  ${unsafeCSS(pl_2)}
  ${unsafeCSS(mt_1)}
  ${unsafeCSS(text_intro)}
  ${unsafeCSS(text_left)}
  ${unsafeCSS(d_flex)}
  ${unsafeCSS(justify_content_between)}
  ${unsafeCSS(align_items_center)}
  .actionbar {
    height: 72px;
    width: 100%;
    background-color: ${unsafeCSS(white)};
  }
  .title {
    color: ${unsafeCSS(n670)};
  }
  .search {
    width: 320px;
    height: 40px;
  }

  .inputIcon {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .search {
      width: 270px;
    }
  }
`;

export default styles;
